import { render, staticRenderFns } from "./fakturkirim.vue?vue&type=template&id=32db756f"
import script from "./fakturkirim.vue?vue&type=script&lang=js"
export * from "./fakturkirim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports